import axios from "axios";
export default {
    data() {
        return {
            strutturePresidioTipoAziendaLocaleOptions: [],
            strutturePresidioTipoAziendaLocalePathResource: "/strutturepresiditipoaziendalocale",
        };
    },
    methods: {
        loadDataStrutturePresidioTipoAzienda() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.strutturePresidioTipoAziendaLocalePathResource;
            axios.get(link)
                .then((response) => {
                    this.strutturePresidioTipoAziendaLocaleOptions = response.data.data.list;
                })
                .catch((error) => {
                    this.$bvToast.toast("Errore nel recupero dati: " + error.message, {
                        title: "",
                        variant: "danger",
                        solid: true,
                    });
                });
        }
    },
};
